export default __webpack_public_path__ + "static/media/business-check.6555b444.svg";